import React, { useEffect } from "react"
import clsx from "clsx"
import {
	Grid
} from "@material-ui/core"

import {
	PhoneLocked as DeviceAndSessionsIcon,
	Security as UserDataIcon
} from "@material-ui/icons"

import {
	AccessibleDrawer,
	SettingsMenuItem
} from "@/components"

import useChatStyles from "@/pages/Attendance/Chat/styles"
import useSidebarDrawerStyles from "@/pages/Attendance/Chat/ChatListPanel/ChatListHeader/styles"
import { isSmallScreen } from "@/utils/checkDevice"
import useDidMount from "@/hooks/useDidMount"

import HeaderDrawer from "@/pages/Attendance/Chat/HeaderDrawer"
import DeviceAndSessionsSettingsDialog from "@/pages/Attendance/Chat/ChatListPanel/ChatListHeader/SecuritySettings/DeviceAndSessionsSettingsDialog"
import ManagementUserAccessDataSettingsDialog from "@/pages/Attendance/Chat/ChatListPanel/ChatListHeader/SecuritySettings/ManagementUserAccessDataSettingsDialog"

type SecuritySettingsProps = {
	openDrawer: boolean
	onClose: () => void
	isCollapsed: boolean
}

const SecuritySettings = (props: SecuritySettingsProps) => {
	const { openDrawer, onClose, isCollapsed } = props

	const chatClasses = useChatStyles()
	const sidebarDrawerClasses = useSidebarDrawerStyles({ isCollapsed })

	const handleCloseDrawer = () => {
		turnOnEventListenerKeydown(false)
		onClose()
	}

	const eventKeyDownHandler = (event: KeyboardEvent) => {
		const { key } = event

		if (key === "Escape") {
			handleCloseDrawer()
		}
	}

	function turnOnEventListenerKeydown (turnOn: boolean) {
		if (turnOn) {
			window.addEventListener(
				"keydown",
				eventKeyDownHandler,
				{ capture: true }
			)
		} else {
			window.removeEventListener(
				"keydown",
				eventKeyDownHandler,
				{ capture: true }
			)
		}
	}

	const handleOpenDeviceAndSessionsSettings = () => {
		DeviceAndSessionsSettingsDialog.open()
	}

	const handleOpenManagementUserAccessDataSettings = () => {
		ManagementUserAccessDataSettingsDialog.open()
	}

	useDidMount(() => {
		turnOnEventListenerKeydown(true)
	})

	useEffect(() => {
		turnOnEventListenerKeydown(false)
	})

	return (
		<>
			<AccessibleDrawer
				id="new-chat-drawer"
				anchor="left"
				open={openDrawer}
				variant="persistent"
				onClose={handleCloseDrawer}
				onMobileBackButtonPress={handleCloseDrawer}
				classes={{
					paper: clsx(chatClasses.drawerPaper, !isSmallScreen && sidebarDrawerClasses.drawerPaperOffset)
				}}
			>
				<Grid
					container
					spacing={2}
				>
					<Grid item xs={12}>
						<HeaderDrawer
							title="Configurações"
							onClose={handleCloseDrawer}
						/>
					</Grid>

					<Grid item xs={12}>
						<SettingsMenuItem
							key="device-and-sessions-settings"
							icon={<DeviceAndSessionsIcon />}
							text={"Dispositivos e Sessões"}
							onClick={handleOpenDeviceAndSessionsSettings}
						/>
					</Grid>
					<Grid item xs={12}>
						<SettingsMenuItem
							key="management-user-access-data-settings"
							icon={<UserDataIcon />}
							text={"Dados de Acesso do Usuário"}
							onClick={handleOpenManagementUserAccessDataSettings}
						/>
					</Grid>
				</Grid>
			</AccessibleDrawer>
		</>
	)
}

export default SecuritySettings
